export default __webpack_public_path__ + "static/media/Artboard 2.7fd2002f.png";